const faqs = [
  {
    q: "Preciso de certificado A1?",
    a: "Sim, para emissão como emitente. O certificado fica cifrado na plataforma com envelope AES.",
  },
  {
    q: "Homologação e produção são separados?",
    a: "Sim. Slots de certificado, filas e configurações distintas por ambiente.",
  },
  {
    q: "Como integro via API?",
    a: "API keys por empresa, rotas /v1/empresas/{id}/... e webhooks. A documentação OpenAPI evolui junto com o produto.",
  },
  {
    q: "Por quanto tempo guardam os XMLs?",
    a: "Retenção mínima de 5 anos, conforme obrigação fiscal brasileira.",
  },
]

export const FaqSection = () => {
  return (
    <section id="faq" className="bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <h2 className="text-3xl font-bold text-slate-900">FAQ</h2>
        <div className="mt-8 space-y-4">
          {faqs.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl border border-slate-200 bg-white p-5 open:shadow-sm"
            >
              <summary className="cursor-pointer list-none font-semibold text-slate-900 marker:content-none">
                {item.q}
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
